import React from 'react'
import styled from 'styled-components';

const Skills = styled.div`
    background-color:var(--background-dark-grey);
    padding: 1.5rem 0 0.75rem 0;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
    &:hover{
        transition: 0.3s;
        transform: scale(1.1);
    }
    .icon{
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 7px;
    }
    @media screen and (max-width: 500px){
        padding: 2rem 0 1.5rem 0;
    }
`;

const ProgressBar = ({ title, icon }) => {
    return (
        <Skills>
            <div className="icon">
                <p>{icon}</p>
                <h6>{title}</h6>
            </div>
        </Skills>
    )
}
export default ProgressBar